var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListAndTabUI',{attrs:{"detail-info":_vm.detailInfo,"nav-list":[
    { title: '未奖励', value: 0, legendClass: 'orange' },
    { title: '已奖励', value: 1, legendClass: 'green' } ],"tab-list":_vm.tabList,"drawModel":_vm.store.drawModel},on:{"load":_vm.handleLoad,"to-explanation":_vm.handleToExplanation,"to-detail":_vm.handleToDetail}})}
var staticRenderFns = []

export { render, staticRenderFns }